"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEpgDescriptionProperty = exports.epgDescriptionPropertyDefinition = void 0;
exports.epgDescriptionPropertyDefinition = {
    view: {
        label: 'EPG Description',
        placeholder: 'Add EPG description',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 200,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'epg-description',
};
const isEpgDescriptionProperty = (prop) => {
    return prop.name === exports.epgDescriptionPropertyDefinition.name;
};
exports.isEpgDescriptionProperty = isEpgDescriptionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXBnLWRlc2NyaXB0aW9uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZXBnLWRlc2NyaXB0aW9uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixXQUFXLEVBQUUscUJBQXFCO0tBQ25DO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsR0FBRztTQUNkO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGlCQUFpQjtDQUNRLENBQUE7QUFJMUIsTUFBTSx3QkFBd0IsR0FBRyxDQUFDLElBQWtCLEVBQWtDLEVBQUU7SUFDN0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHdDQUFnQyxDQUFDLElBQUksQ0FBQTtBQUM1RCxDQUFDLENBQUE7QUFGWSxRQUFBLHdCQUF3Qiw0QkFFcEMifQ==